module.exports = __webpack_public_path__ + "static/img/9.3dd6be0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/9.jpg
// module id = 5eaT
// module chunks = 1